<template>
  <b-container fluid>
    <router-view :key="$route.name + ($route.params.id || '')"/>
    <NotificationMessage />
  </b-container>
</template>

<script>
import NotificationMessage from '@/components/NotificationMessage.vue';

export default {
  components: { NotificationMessage },

};
</script>

<style lang="less">
  .container {
    margin-top: 71px;
  }
  .container-fluid {
    margin-top: 71px;
  }

  .base-row-padded {
    padding: 8px;
  }
</style>
